/**
 * Terms of Service (V1 auth-profiles-gdpr — S-27 About/legal). Static, serious.
 */
import { Link } from "react-router-dom";
import { LegalPage } from "./legal-page.js";

const EFFECTIVE = "2026-07-01";

export function TermsScreen() {
  return (
    <LegalPage title="Terms of Service">
      <p className="text-dim">Effective {EFFECTIVE}.</p>

      <h2>1. The service</h2>
      <p>
        Humble is a dating application operated at humble.ekaii.fr ("the service"). Its
        signature mechanic is the Reject-Match: a mutual left-swipe creates a match, exactly as
        a mutual right-swipe does. By creating an account you accept these terms and the{" "}
        <Link to="/legal/privacy">Privacy Policy</Link>.
      </p>

      <h2>2. Eligibility</h2>
      <p>
        You must be 18 years of age or older. We verify age at signup and enforce device-level
        locks against underage access. Accounts found to belong to minors are removed and their
        data deleted.
      </p>

      <h2>3. Your account</h2>
      <p>
        One account per person, tied to a verified email address. You are responsible for
        keeping your credentials private. You may pause your account at any time, and delete it
        with a 14-day grace period after which erasure is permanent.
      </p>

      <h2>4. Community rules</h2>
      <ul style={{ paddingLeft: 20 }}>
        <li>No harassment, hate speech, or threats. The app's humor targets situations; you may not target people.</li>
        <li>No minors, no impersonation, no commercial solicitation, no scams.</li>
        <li>No sexual content involving non-consenting parties; no illegal content of any kind.</li>
        <li>One person per account; no automated access.</li>
      </ul>
      <p>
        Violations can lead to content removal, feature restrictions, or account and device
        bans. Blocking, reporting and unmatching work for every user against every user at all
        times — no purchase alters that.
      </p>

      <h2>5. Virtual items & subscriptions</h2>
      <p>
        Shields, Super Rejects, Boosts, Crushes, Berserker Mode sessions and Premium are digital
        services consumed inside the app. Prices are shown at purchase; payment is processed by
        Stripe. Consumed or time-expired items are not refunded. "Invincibility" cosmetics
        (Berserker Mode) are visual theater only: they never disable another user's safety
        controls. Subscriptions renew until canceled via the billing portal; cancellation takes
        effect at the end of the paid period. EU customers: by starting to use a digital item
        immediately you consent to immediate performance and acknowledge the loss of the
        14-day withdrawal right for that item, as permitted by Directive 2011/83/EU.
      </p>

      <h2>6. Content</h2>
      <p>
        You keep ownership of what you upload and grant Humble a license to display it inside
        the service. All uploads pass moderation. The "Enemy Takeover" feature only ever runs
        with the explicit consent of the profile owner, is limited to bio and prompt overlays,
        and can be ended by the owner instantly.
      </p>

      <h2>7. Liability</h2>
      <p>
        Humble is provided "as is". We do not run background checks on members. Exercise the
        judgment described in the <Link to="/safety">Safety Center</Link> when meeting people.
        To the extent permitted by law, our liability is limited to the amounts you paid us in
        the twelve months preceding a claim. Nothing in these terms limits liability for
        intentional misconduct or gross negligence.
      </p>

      <h2>8. Termination & changes</h2>
      <p>
        You may delete your account at any time. We may suspend or terminate accounts that
        violate these terms, with an appeal path (appeal@humble.ekaii.fr). We may amend these
        terms with 30 days' notice for material changes; continued use after the notice period
        is acceptance.
      </p>

      <h2>9. Contact</h2>
      <p>
        support@humble.ekaii.fr · These terms are governed by French law; mandatory consumer
        protections of your country of residence remain unaffected.
      </p>
    </LegalPage>
  );
}
